import useService from "../../../../../hooks/useService";

function hasPermission(permissions = [], permission) {
  return permissions.includes(permission);
}

export default function useProviderDetailPermissions({ activeProvObj = {}, providerId } = {}) {
  const currentUserService = useService("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];
  const loggedInUser = currentUserService?.user;
  const isProviderUser = loggedInUser?.entity?.entity_type_label === "Provider";
  const isRestrictedProviderUser =
    isProviderUser && Boolean(providerId) && providerId !== activeProvObj?.[providerId];

  const canViewProvider = hasPermission(permissions, "provider.view_provider");
  const canEditProvider =
    hasPermission(permissions, "provider.change_provider") && !isRestrictedProviderUser;

  const canViewEmails = hasPermission(permissions, "provider.view_provideremail");
  const canAddEmails =
    hasPermission(permissions, "provider.add_provideremail") && !isRestrictedProviderUser;
  const canEditEmails =
    hasPermission(permissions, "provider.change_provideremail") && !isRestrictedProviderUser;
  const canDeleteEmails =
    hasPermission(permissions, "provider.delete_provideremail") && !isRestrictedProviderUser;

  const canViewPhones = hasPermission(permissions, "provider.view_providercontactinfo");
  const canAddPhones =
    hasPermission(permissions, "provider.add_providercontactinfo") && !isRestrictedProviderUser;
  const canEditPhones =
    hasPermission(permissions, "provider.change_providercontactinfo") && !isRestrictedProviderUser;
  const canDeletePhones =
    hasPermission(permissions, "provider.delete_providercontactinfo") && !isRestrictedProviderUser;

  const canViewOfficeHours = hasPermission(permissions, "provider.view_providerofficehours");
  const canAddHoursOfOperation =
    hasPermission(permissions, "provider.add_providerofficehours") && !isRestrictedProviderUser;
  const canEditHoursOfOperation =
    hasPermission(permissions, "provider.change_providerofficehours") && !isRestrictedProviderUser;
  const canDeleteHoursOfOperation =
    hasPermission(permissions, "provider.delete_providerofficehours") && !isRestrictedProviderUser;

  const canAddProviderServices =
    hasPermission(permissions, "provider.add_providerservice") && !isRestrictedProviderUser;
  const canDeleteProviderServices =
    hasPermission(permissions, "provider.delete_providerservice") && !isRestrictedProviderUser;

  return {
    canAddEmails,
    canAddHoursOfOperation,
    canAddPhones,
    canAddProviderServices,
    canDeleteEmails,
    canDeleteHoursOfOperation,
    canDeletePhones,
    canDeleteProviderServices,
    canEditAdditionalContacts:
      canAddEmails ||
      canEditEmails ||
      canDeleteEmails ||
      canAddPhones ||
      canEditPhones ||
      canDeletePhones,
    canEditEmails,
    canEditHoursOfOperation,
    canEditPhones,
    canEditProvider,
    canManageProviderServices: canAddProviderServices || canDeleteProviderServices,
    canViewEmails,
    canViewFieldOptions: hasPermission(permissions, "utilities.view_fieldoptions"),
    canViewOfficeHours,
    canViewPhones,
    canViewProvider,
    canViewProviderRelation: hasPermission(permissions, "provider.view_providerrelation"),
    isProviderUser,
    isRestrictedProviderUser,
    shouldShowViewAllClients: !isProviderUser,
  };
}
